// src/components/NumberTaxiForRentOrSaleTable/NumberTaxiForRentOrSaleTable.js

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./NumberTaxiForRentOrSaleTable.css";

const NumberTaxiForRentOrSaleTable = () => {
  const { id: uid } = useParams(); // קבלת UID מה-URL
  const [right, setRight] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`/api/publicrights/item/${uid}`);
        setRight(res.data);
      } catch (err) {
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [uid]);

  if (loading)
    return <div className="NumberTaxiForRentOrSaleTable_loading">טוען...</div>;

  if (notFound || !right)
    return (
      <div className="NumberTaxiForRentOrSaleTable_notfound">
        ❌ לא נמצאה זכות עם מזהה {uid}
      </div>
    );

  return (
    
    <div className="NumberTaxiForRentOrSaleTable_wrapper">
      <h1 className="NumberTaxiForRentOrSaleTable_title">פרטי זכות ציבורית </h1>
      <table className="NumberTaxiForRentOrSaleTable_table">
        <tbody>
          <tr className="NumberTaxiForRentOrSaleTable_tr">
            <td className="NumberTaxiForRentOrSaleTable_td"><strong>שם:</strong></td>
            <td className="NumberTaxiForRentOrSaleTable_td">{right.Name}</td>
          </tr>
          <tr className="NumberTaxiForRentOrSaleTable_tr">
            <td className="NumberTaxiForRentOrSaleTable_td"><strong>סוג:</strong></td>
            <td className="NumberTaxiForRentOrSaleTable_td">{right.Type}</td>
          </tr>
          <tr className="NumberTaxiForRentOrSaleTable_tr">
            <td className="NumberTaxiForRentOrSaleTable_td"><strong>מיידי:</strong></td>
            <td className="NumberTaxiForRentOrSaleTable_td">{right.Immediately}</td>
          </tr>
<tr className="NumberTaxiForRentOrSaleTable_tr">
  <td className="NumberTaxiForRentOrSaleTable_td"><strong>מחיר:</strong></td>
  <td className="NumberTaxiForRentOrSaleTable_td">{right.Price}</td>
</tr>
<tr className="NumberTaxiForRentOrSaleTable_tr">
  <td colSpan="2" className="NumberTaxiForRentOrSaleTable_note">
    המחיר אינו כולל מע"מ
  </td>
</tr>

          <tr className="NumberTaxiForRentOrSaleTable_tr">
            <td className="NumberTaxiForRentOrSaleTable_td"><strong>טלפון:</strong></td>
            <td className="NumberTaxiForRentOrSaleTable_td">{right.Phone}</td>
          </tr>
          <tr className="NumberTaxiForRentOrSaleTable_tr">
            <td className="NumberTaxiForRentOrSaleTable_td"><strong>וואטסאפ:</strong></td>
            <td className="NumberTaxiForRentOrSaleTable_td">
              <a href={right.WhatsappLink} target="_blank" rel="noreferrer">
                שלח הודעה
              </a>
            </td>
          </tr>
          <tr className="NumberTaxiForRentOrSaleTable_tr">
            <td className="NumberTaxiForRentOrSaleTable_td"><strong>סטטוס:</strong></td>
            <td className="NumberTaxiForRentOrSaleTable_td">{right.Source || "-"}</td>
          </tr>
          
        </tbody>
      </table>
                  <div className="NumberTaxiForRentOrSaleTable_backbuttonwrapper">
          {right.Type === "להשכרה" ? (
            <a
              href="/NumberTaxiForRent"
              className="NumberTaxiForRentOrSaleTable_backbutton"
            >
              לכל זכויות ציבוריות להשכרה
            </a>
          ) : (
            <a
              href="/NumberTaxiForSell"
              className="NumberTaxiForRentOrSaleTable_backbutton"
            >
              לכל זכויות ציבוריות למכירה
            </a>
          )}
        </div>
        
    </div>
  );
};

export default NumberTaxiForRentOrSaleTable;
